import { toast } from "react-toastify";
import axios from "../../axios";
import {
  ADD_ITEM,
  DELETE_ITEM,
  GET_ITEM,
  GET_ITEMS,
  IMPORT_ITEM_EXCEL,
  UPDATE_ITEM,
} from "../types";
// import { setAlert } from "./alert";
import Swal from "sweetalert2";

export const getItems = (pageOrParams) => async (dispatch) => {
  try {
    const params = typeof pageOrParams === "object" ? pageOrParams : {};
    if (typeof pageOrParams !== "object" && pageOrParams !== undefined && pageOrParams !== null) {
      params.page = pageOrParams;
    }
    const res = await axios.get("/item/all", { params });
    if (res.data.code === 1) {
      dispatch({ type: GET_ITEMS, payload: res.data });
    }
  } catch (err) {
    // dispatch(setAlert(err.message, "danger"));
    Swal.fire({
      title: "Error",
      text: err.message,
      icon: "error",
    });
  }
};

export const getItem = (id) => async (dispatch) => {
  try {
    const res = await axios.get(`/item/${id}`);
    if (res.data.code === 1) {
      dispatch({ type: GET_ITEM, payload: res.data.data });
    }
  } catch (err) {
    // dispatch(setAlert(err.message, "danger"));
    Swal.fire({
      title: "Error",
      text: err.message,
      icon: "error",
    });
  }
};

export const addItem = (formData) => async (dispatch) => {
  try {
    const res = await axios.post("/item/add", formData);
    if (res.data.code === 1) {
      dispatch({ type: ADD_ITEM, payload: res.data.data });
      // dispatch(setAlert(res.data.message, 'success'));
      Swal.fire({
        title: "Success",
        text: res.data.message,
        icon: "success",
      });
      return res.data;
    } else {
      // dispatch(setAlert(res.data.message, "warning"));
      Swal.fire({
        title: "Warning",
        text: res.data.message,
        icon: "warning",
      });
    }
  } catch (err) {
    // dispatch(setAlert(err.message, "danger"));
    const msg = err.response?.data?.message || err.message;
    Swal.fire({
      title: "Error",
      text: msg,
      icon: "error",
    });
  }
};

export const updateItem = (formData) => async (dispatch) => {
  try {
    const res = await axios.post(`/item/update`, formData);
    if (res.data.code === 1) {
      dispatch({ type: UPDATE_ITEM, payload: res.data.data });
      // dispatch(setAlert(res.data.message, "success"));
      Swal.fire({
        title: "Success",
        text: res.data.message,
        icon: "success",
      });
      return res.data;
    } else {
      // dispatch(setAlert(res.data.message, "warning"));
      Swal.fire({
        title: "Warning",
        text: res.data.message,
        icon: "warning",
      });
    }
  } catch (err) {
    // dispatch(setAlert(err.message, "danger"));
    const msg = err.response?.data?.message || err.message;
    Swal.fire({
      title: "Error",
      text: msg,
      icon: "error",
    });
  }
};

export const deleteItem = (id) => async (dispatch) => {
  try {
    const res = await axios.post(`/item/delete/${id}`);
    if (res.data.code === 1) {
      // dispatch(setAlert(res.data.message, "success"));
      Swal.fire({
        title: "Success",
        text: res.data.message,
        icon: "success",
      });
      dispatch({ type: DELETE_ITEM, payload: res.data.data });
      return res.data;
    } else {
      // dispatch(setAlert(res.data.message, "warning"));

      Swal.fire({
        title: "Warning",
        text: res.data.message,
        icon: "warning",
      });
    }
  } catch (err) {
    // dispatch(setAlert(err.message, "danger"));
    const msg = err.response?.data?.message || err.message;
    Swal.fire({
      title: "Error",
      text: msg,
      icon: "error",
    });
  }
};

export const importItemExcel = (formData) => async (dispatch) => {
  try {
    const res = await axios.post("/item/import-excel", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    if (res.data.code === 1 || res.data.code === "1") {
      dispatch({ type: IMPORT_ITEM_EXCEL, payload: res.data.data });

      const stats = Object.values(res.data.data || {})[0] || {};

      Swal.fire({
        title: "Import Successful",
        icon: "success",
        html: `
          <table style="width:100%; text-align:left; border-collapse:collapse;">
            <tr><td>📊 Total Rows Processed</td><td><b>${stats.totalRowsProcessed ?? 0}</b></td></tr>
            <tr><td>✅ Successfully Inserted</td><td><b>${stats.inserted ?? 0}</b></td></tr>
            <tr><td>⚠️ Skipped (Duplicates)</td><td><b>${stats.skippedDuplicates ?? 0}</b></td></tr>
          </table>
        `,
      });

      return { code: 1, stats };
    }

    if (res.data.code === 2 || res.data.code === "2") {
      Swal.fire({ title: "Warning", text: res.data.message, icon: "warning" });
      return res.data;
    }
  } catch (err) {
    Swal.fire({
      title: "Error",
      text: err?.response?.data?.message || "Import failed.",
      icon: "error",
    });
    return { code: 0 };
  }
};
